import { ClientNode } from '../model/client-model/client-node';
import { NodeListItem } from '../model/node-list-item';
import { Node } from '../services/climate-engine/ccc-model-utility/ccc-model-utility';

export function nodeExistsInTree(node: NodeListItem, nodes: Node[]): boolean {
  for (const n of nodes) {
    if ((<NodeListItem | ClientNode>n).childNodes?.includes(node.id)) {
      return true;
    }
  }
  return false;
}
